import React from 'react';
import { GlassCard } from '../canvas';
import { Button } from '../../sdk';

/**
 * Export result modal with preview
 * @param {Object} props
 * @param {string} props.exportUrl - Data URL of exported image
 * @param {number} props.slideIndex - Slide index (0-based)
 * @param {string} props.format - Export format ('png' or 'jpeg')
 * @param {function} props.onClose - Callback to close modal
 */
export function ExportModal({ exportUrl, slideIndex, format = 'png', bgRounded = true, onClose }) {
  if (!exportUrl) return null;

  const extension = format === 'jpeg' ? 'jpg' : 'png';
  const formatLabel = format === 'jpeg' ? 'JPEG' : 'PNG';

  return (
    <div
      className="fixed inset-0 z-50 grid place-items-center bg-black/60 p-6"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div className="w-full max-w-[820px] max-h-[85vh]" onClick={(e) => e.stopPropagation()}>
        <GlassCard className="p-5">
          <div className="flex items-center justify-between gap-3">
            <div>
              <div className="text-sm font-semibold text-white/90">{formatLabel} export ready</div>
              <div className="mt-1 text-xs text-white/60">
                If download is blocked — right-click → &quot;Save image as…&quot;.
              </div>
            </div>
            <div className="flex items-center gap-2">
              <Button href={exportUrl} title="Open in a new tab">
                Open
              </Button>
              <Button onClick={onClose}>
                Close
              </Button>
            </div>
          </div>

          <div className="mt-4 grid place-items-center">
            {/* 
              Slide is 1080×1350 with 72px circular corner radius.
              Use proportional border-radius so the CSS rounding scales
              identically to the baked-in content rounding at any display size.
              72/1080 ≈ 6.667% width, 72/1350 ≈ 5.333% height → always equal px values.
            */}
            <img
              src={exportUrl}
              alt={`Magic Forest slide ${slideIndex + 1} export`}
              className="max-h-[55vh] w-auto border border-white/10"
              style={bgRounded ? { borderRadius: '6.667% / 5.333%' } : undefined}
            />
          </div>

          <div className="mt-4 text-xs text-white/55">
            Filename suggestion:{' '}
            <span className="text-white/75">magic-forest-slide-{slideIndex + 1}.{extension}</span>
          </div>
        </GlassCard>
      </div>
    </div>
  );
}
